import { smartbillApi, paymentsApi } from '../httpService';


const getPlans = async (query: any = {}) => {
    try {
        const result = await smartbillApi.get('/api/v1/plans', {
            params: query
        });
        console.log('Plans API Response:', result);
        // Extract the plans array from the response
        const plans = result.data.data || result.data || [];
        
        return {
            success: true,
            data: plans,
            pager: {
                page: query.page || 1,
                pageSize: plans.length || 10,
                totalCount: plans.length
            }
        };
    } catch (error: any) {
        console.log(error,"smartbill error");
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}


const getPlan = async (id: string) => {
    try {
        const result = await smartbillApi.get(`/api/v1/plans/${id}`);
        return {
            success: true,
            data: result.data.data || result.data,
        };
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return {
                success: false,
                notFound: true,
                message: "Plan not found"
            };
        }

        return {
            success: false,
            notFound: false,
            message: "An unexpected Error"
        };
    }
}


const createPlan = async (data: any) => {
    try {
        const result = await smartbillApi.post('/api/v1/plans', data);
        return {
            success: true,
            data: result.data.data || result.data,
            message: 'Plan created successfully'
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}


const updatePlan = async (id: string, data: any) => {
    try {
        console.log('Updating plan with data:', data);
        const result = await smartbillApi.put(`/api/v1/plans/${id}`, data);
        console.log('Plan update response:', result);
        return {
            success: true,
            data: result.data.data || result.data,
            message: 'Plan updated successfully'
        };
    } catch (error: any) {
        console.log('Plan update error:', error);
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}


const deletePlan = async (id: string) => {
    try {
        const result = await smartbillApi.delete(`/api/v1/plans/${id}`);
        return {
            success: true,
            message: 'Plan deleted successfully'
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}


// Plan Features APIs
const getPlanFeatures = async (planId?: string) => {
    try {
        const params = planId ? { planId } : {};
        const result = await smartbillApi.get('/api/v1/plan-features', {
            params
        });
        return {
            success: true,
            data: result.data.data || result.data,
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

const getAllFeatures = async () => {
    try {
        // Use the payments API to get master features list
        const result = await paymentsApi.get('/api/v1/features');
        return {
            success: true,
            data: result.data.data || result.data,
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

const createPlanFeature = async (data: any) => {
    try {
        const result = await smartbillApi.post('/api/v1/plan-features', data);
        return {
            success: true,
            data: result.data.data || result.data,
            message: 'Plan feature created successfully'
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

const deletePlanFeature = async (id: string) => {
    try {
        const result = await smartbillApi.delete(`/api/v1/plan-features/${id}`);
        return {
            success: true,
            message: 'Plan feature removed successfully'
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

const createPlanFeaturesBulk = async (featurePayloads: Array<{ displayName: string; description?: string; systemCode: string; planId: string; planIdAsUUID?: string; }>) => {
    try {
        const result = await smartbillApi.post('/api/v1/plan-features/bulk', featurePayloads);
        return {
            success: true,
            data: result.data.data || result.data,
            message: `${featurePayloads.length} feature(s) added to plan successfully`
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

// Plan Schools APIs using school-plans endpoint
const getPlanSchools = async (planId?: string) => {
    try {
        const params = planId ? { planId, include: 'school' } : { include: 'school' };
        const result = await smartbillApi.get('/api/v1/school-plans', {
            params
        });
        return {
            success: true,
            data: result.data.data || result.data,
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

const createSchoolPlan = async (data: any) => {
    try {
        const result = await smartbillApi.post('/api/v1/school-plans', data);
        return {
            success: true,
            data: result.data.data || result.data,
            message: 'School added to plan successfully'
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

// New method to add multiple schools to a plan at once
const createSchoolPlans = async (planId: string, schoolIds: number[]) => {
    try {
        const result = await smartbillApi.post('/api/v1/school-plans', {
            planId,
            schoolIds, // Array of school IDs
            planIdAsUUID: planId,
            billingDate: new Date().toISOString().split('T')[0]
        });
        return {
            success: true,
            data: result.data.data || result.data,
            message: `${schoolIds.length} school(s) added to plan successfully`
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}

const deleteSchoolPlan = async (id: string) => {
    try {
        const result = await smartbillApi.delete(`/api/v1/school-plans/${id}`);
        return {
            success: true,
            message: 'School removed from plan successfully'
        };
    } catch (error: any) {
        return {
            success: false,
            message: error.response?.data?.message || "An unexpected Error"
        };
    }
}


export default {
    getPlans,
    getPlan,
    createPlan,
    updatePlan,
    deletePlan,
    // Plan Features
    getPlanFeatures,
    getAllFeatures,
    createPlanFeature,
    deletePlanFeature,
    createPlanFeaturesBulk,
    // Plan Schools
    getPlanSchools,
    createSchoolPlan,
    createSchoolPlans, // New method for multiple schools
    deleteSchoolPlan,
}